module.exports = __webpack_public_path__ + "img/a11y-stability-2_en.caf3c78.jpg";